function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { onResize } from '../../../index';
import '../polyfill/wdh-nodelist-foreach';
var WDHEqualHeight = /*#__PURE__*/function () {
  function WDHEqualHeight() {
    var _this = this;
    _classCallCheck(this, WDHEqualHeight);
    this.selectors = [];
    this.callbacks = [];
    onResize(function () {
      _this.execute();
    });
  }
  return _createClass(WDHEqualHeight, [{
    key: "execute",
    value: function execute() {
      for (var i = 0, len = this.selectors.length; i < len; i += 1) {
        var height = this.equalheight(this.selectors[i]);
        var callback = this.callbacks[i];
        callback(height);
      }
    }
  }, {
    key: "register",
    value: function register(nodeList, ignoreLineBreak, callback) {
      this.equalheight({
        nodeList: nodeList,
        ignoreLineBreak: ignoreLineBreak
      });
      this.selectors.push({
        nodeList: nodeList,
        ignoreLineBreak: ignoreLineBreak
      });
      if (this.callback !== undefined) {
        this.callbacks.push(callback);
      } else {
        this.callbacks.push(function () {});
      }
    }
  }, {
    key: "trigger",
    value: function trigger(nodeList, ignoreLineBreak, callback) {
      var height = this.equalheight({
        nodeList: nodeList,
        ignoreLineBreak: ignoreLineBreak
      });
      if (callback !== undefined) {
        callback(height);
      }
    }
  }, {
    key: "equalheight",
    value: function equalheight(data) {
      var currentTallest = 0;
      var currentRowStart = 0;
      var rowDivs = [];
      var topPosition = 0;
      var currentDiv;
      var nodeList = data.nodeList;
      var ignoreLineBreak = data.ignoreLineBreak;
      nodeList.forEach(function (node) {
        node.style.height = 'auto';
      });
      nodeList.forEach(function (node) {
        topPosition = node.offsetTop;
        if (currentRowStart !== topPosition && ignoreLineBreak !== true) {
          for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
            rowDivs[currentDiv].style.height = "".concat(currentTallest, "px");
          }
          rowDivs.length = 0; // empty the array
          currentRowStart = topPosition;
          currentTallest = node.offsetHeight;
          rowDivs.push(node);
        } else {
          rowDivs.push(node);
          if (currentTallest < node.offsetHeight) {
            currentTallest = node.offsetHeight;
          }
        }
      });
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
        rowDivs[currentDiv].style.height = "".concat(currentTallest, "px");
      }
      return currentTallest;
    }
  }]);
}();
var equalHeight = new WDHEqualHeight();
var triggerEqualHeight = function triggerEqualHeight() {
  equalHeight.trigger.apply(equalHeight, arguments);
};
var registerEqualHeight = function registerEqualHeight() {
  equalHeight.register.apply(equalHeight, arguments);
};
export { triggerEqualHeight, registerEqualHeight };